import {useQuery} from '@tanstack/react-query';

import {useStores} from '../../stores/use-stores';
import {getPaymentServices} from '../../transport/paymentCardApiV2';

import type {GetPaymentServicesResponse} from './types';

export const PAYMENT_SERVICES_QUERY_KEY_BASE = ['paymentServices'] as const;

/** @deprecated Use PAYMENT_SERVICES_QUERY_KEY_BASE for prefix matching */
export const PAYMENT_SERVICES_QUERY_KEY = PAYMENT_SERVICES_QUERY_KEY_BASE;

/**
 * Fetch available payment services for the current shop
 * Returns { services: PaymentService[] }
 *
 * Query key includes storeId for proper cache scoping per store.
 * Cache automatically invalidates when user switches stores.
 *
 * @param enabled - Whether to fetch (default: true)
 */
export const usePaymentServices = (enabled: boolean = true) => {
  const {shopSelectionStore} = useStores();
  const storeId = shopSelectionStore.selectedStore?.id;

  return useQuery<GetPaymentServicesResponse>({
    queryKey: [...PAYMENT_SERVICES_QUERY_KEY_BASE, storeId],
    queryFn: getPaymentServices,
    enabled: enabled && !!storeId,
  });
};
